import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from 'core/components/radio';

import useStyles from './change-picker.styles';

export const ChoiceList = ({ legend, name, options, value, onChange }) => {
  const classes = useStyles();
  return (
    <fieldset className={classes.fieldset}>
      <legend className={classes.legend}>{legend}</legend>
      <Radio
        id={name}
        name={name}
        options={options}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        optionsSideBySide={false}
        className={classes.formControl}
        containerClassName={classes.choices}
        labelClassName={classes.choiceLabel}
      />
    </fieldset>
  );
};

ChoiceList.propTypes = {
  legend: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

ChoiceList.defaultProps = {
  value: null
};

// The top of the Make a change drawer: which policy (only when the customer has more than one open policy), then
// "What's changing?".
const ChangePicker = ({ policies, policyId, onPolicyChange, changeTypes, changeType, onChangeTypeChange }) => {
  const classes = useStyles();
  return (
    <>
      {policies.length > 1 && (
        <ChoiceList
          legend="Policy"
          name="make-a-change-policy"
          options={policies.map(({ id, label }) => ({
            value: id,
            label: (
              <span>
                {label}
                <span className={classes.policyId}>{id}</span>
              </span>
            )
          }))}
          value={policyId}
          onChange={onPolicyChange}
        />
      )}
      <ChoiceList
        legend="What's changing?"
        name="make-a-change-type"
        options={changeTypes.map(({ value, label }) => ({ value, label }))}
        value={changeType}
        onChange={onChangeTypeChange}
      />
    </>
  );
};

ChangePicker.propTypes = {
  policies: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
  policyId: PropTypes.string.isRequired,
  onPolicyChange: PropTypes.func.isRequired,
  changeTypes: PropTypes.array.isRequired,
  changeType: PropTypes.string,
  onChangeTypeChange: PropTypes.func.isRequired
};

ChangePicker.defaultProps = {
  changeType: null
};

export default ChangePicker;
